{
  "password": {
    "oneNumber": "The password must contain at least 1 digit",
    "oneSymbol": "The password must contain at least 1 special character",
    "oneLowerCase": "The password must contain at least 1 lowercase Latin later",
    "oneUpperCase": "The password must contain at least 1 uppercase Latin later",
    "minSymbols": "The password must contain Latin letters, numbers and special characters, at least 8 characters",
    "maxSymbols": "The password is no longer than 255 characters",
    "notEqual": "The two passwords that you entered do not match!"
  },
  "form": {
    "required": "Required to fill",
    "ipValidate": "Incorrect IP",
    "notValid": "Form is not valid",
    "requiredError": "Required fields must be filled",
    "incorrectFormat": "Incorrect format",
    "incorrectValue": "Incorrect value",
    "domain": "Only Latin letters, digits, dots, and hyphens are allowed",
    "maxLength": "Must not exceed {{max}} characters",
    "passwordsMismatch": "Passwords do not match",
    "missingOption": "Selected option is not valid",
    "rjsf": {
      "incorrectSchema": "Invalid schema format"
    },
    "latinWithScores": "Only Latin letters, digits and underscores"
  },
  "oidc": {
    "nameFormat": "Name must start with a letter and contain only lowercase letters, digits, and underscores"
  },
  "required": "Required field",
  "max": "Exceeded the maximum",
  "min": "Insufficient minimum"
}